export const colors = {
    white: "hover:bg-gray-100 active:bg-gray-200",
    grey: "text-gray-700 bg-gray-200 hover:bg-gray-300 hover:text-gray-900 focus:ring-gray-200 active:bg-gray-200 border-transparent",
    voice: "text-white bg-voice focus:ring-voice hover:bg-voice-dark border-transparent active:bg-voice-xdark",
    black: "text-white bg-gray-900 hover:bg-gray-700 focus:ring-gray-900 active:bg-gray-90 border-transparent",
    danger: "text-white bg-danger hover:bg-danger-hover active:bg-danger-active border-transparent",
    green: "text-white bg-green-600 focus:ring-green-600 hover:bg-green-700",
    voiceOutline:
        "text-voice border-voice hover:bg-voice-xlight active:bg-voice-light",
    dangerOutline:
        "border-danger text-danger hover:bg-danger-light-hover active:bg-danger-light-active",
};

export const disabledStates = {
    fill: "disabled:bg-gray-200 disabled:text-gray-700",
    outline:
        "disabled:border disabled:border-gray-700 disabled:text-gray-700 disabled:bg-transparent",
    ghost: "disabled:text-gray-700 disabled:bg-transparent",
};

export const disabledColors = {
    white: disabledStates.outline,
    grey: disabledStates.fill,
    voice: disabledStates.fill,
    black: disabledStates.fill,
    danger: disabledStates.fill,
    green: disabledStates.fill,
    voiceOutline: disabledStates.outline,
    dangerOutline: disabledStates.outline,
};

export const sizes = {
    sm: "px-2 py-1 text-xs rounded-md",
    md: "px-4 py-2 text-sm rounded-lg",
    lg: "px-6 py-3 text-base rounded-lg",
    xl: "px-6 py-3 text-lg rounded-lg",
};

export const loadingSizes = {
    sm: "size-4",
    md: "size-5",
    lg: "size-6",
    xl: "size-7",
};

export const iconSizes = {
    sm: "size-5",
    md: "size-6",
    lg: "size-6",
    xl: "size-6",
};
